"use client";

import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { useAppTheme } from "@/contexts/AppThemeContext";
import { AuthProvider } from "@/lib/auth/components";

export function RootLayoutContent({
  children,
  authProvider,
}: {
  children: React.ReactNode;
  /**
   * Resolved by the root layout, which is a server component and can read
   * AUTH_PROVIDER at request time. Threaded rather than read here because this
   * is a client component: in the browser only NEXT_PUBLIC_* exists, and only
   * as a build-time constant.
   */
  authProvider?: string;
}) {
  const { muiTheme } = useAppTheme();
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <AuthProvider provider={authProvider}>{children}</AuthProvider>
    </ThemeProvider>
  );
}
